'use client'

import React from 'react'
import { ButtonGroup } from '@/payload-types'
import { CMSButtonGroup } from '@/ui/components/CMSButtonGroup'

type ButtonsSectionProps = {
  buttons: ButtonGroup | null | undefined
}

export const ButtonsSection: React.FC<ButtonsSectionProps> = ({ buttons }) => {
  if (!buttons || buttons.length === 0) return null

  return (
    <div className="flex flex-wrap gap-4 justify-center">
      <CMSButtonGroup buttons={buttons} fixedSize="md" />
    </div>
  )
}
